import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/utils/auth-context";
import ArrowIcon from "@/components/UI/ArrowIcon";

export default function CourseNavigationLayout({ navItems }) {
  const { firestoreUser } = useAuth();

  const availableNavItems = (
    firestoreUser?.access
      ? navItems.filter((item) => firestoreUser.access?.includes(item.value))
      : []
  ).map((item, index) => ({ ...item, index: index + 1 }));

  return (
    <div className="coursePage-nav page">
      <div className="page-navigation">
        {availableNavItems.map(({ path, label, index, externalLink }) =>
          externalLink ? (
            <a
              key={label}
              href={externalLink}
              target="_blank"
              rel="noopener noreferrer"
              className="page-navigation__item"
            >
              <p className="page-navigation__item__index">{index}</p>
              <p>{label}</p>
              <ArrowIcon isActive={false} />
            </a>
          ) : (
            <NavLink
              key={path}
              to={path}
              className={({ isActive }) =>
                `${isActive ? "page-navigation__item--active" : ""} page-navigation__item`
              }
            >
              {({ isActive }) => (
                <>
                  <p className="page-navigation__item__index">{index}</p>
                  <p>{label}</p>
                  <ArrowIcon isActive={isActive} />
                </>
              )}
            </NavLink>
          ),
        )}
      </div>
      <div className="page-content">
        <Outlet />
      </div>
    </div>
  );
}
